import React, { ReactNode, useEffect, useRef } from 'react'

import { SizesProvider } from '../../../hooks/useSizes'
import { FrontendUser } from '../../../utils/types'
import CommonFooter from '../CommonFooter/CommonFooter'
import CommonHeaderLight, { HEADER_THEMES, HeaderMode, HeaderTheme } from '../CommonHeader/CommonHeaderLight'
import styles from './CommonPage.module.scss'

type Props = {
  children: ReactNode
  user?: FrontendUser
  scrollable?: boolean
  scrolled?: boolean
  headerColor?: string
  handleScroll?: (e: any) => void
  mode?: HeaderMode
  rescroll?: number
  theme?: HeaderTheme
  hideFooter?: boolean
  style?: React.CSSProperties
}

const CommonPageLight: React.FC<Props> = ({
  children,
  mode,
  headerColor,
  user,
  scrolled,
  scrollable,
  handleScroll,
  rescroll,
  theme = HEADER_THEMES.DARK,
  hideFooter,
  style,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    scrollRef.current?.scrollTo(0, 0)
  }, [rescroll])

  return (
    <SizesProvider>
      <div className={styles.container} data-scrollable={scrollable} style={style}>
        {!scrollable && <CommonHeaderLight mode={mode} color={headerColor} theme={theme} />}
        <div className={styles.scrollable} onScroll={handleScroll} ref={scrollRef}>
          {scrollable && <CommonHeaderLight scrollable scrolled={scrolled} mode={mode} color={headerColor} />}
          {children}
          {!hideFooter && <CommonFooter light />}
        </div>
      </div>
    </SizesProvider>
  )
}

export default CommonPageLight
